import faker from "@faker-js/faker";
import { Address } from "@src/core/models/address";

export const mockAddress = (overrides?: Address): Address => ({
  createdAt: faker.date.past(),
  createdBy: faker.datatype.uuid(),
  addressLineOne: faker.address.streetAddress(),
  addressLineTwo: faker.address.streetAddress(),
  id: faker.datatype.uuid(),
  city: faker.address.city(),
  country: faker.address.country(),
  state: faker.address.state(),
  zipCode: faker.address.zipCode(),
  updatedAt: faker.date.past(),
  updatedBy: faker.datatype.uuid(),
  ...(overrides || {}),
});
